import getGifSkeleton from 'shared/components/gif-skeleton'
import { getArtistChannels } from 'shared/api'

export const fetchArtistInfo = async () => {
    const { results = [] } = await getArtistChannels({ filter: '', freelance: false, order: 'desc', sort: 'updatetime', rating: 'pg' })
    const newGifs = results
        .filter(({ featured_gif = {} }: any) => featured_gif.images.fixed_width)
        .map(({ featured_gif = {}, user = {} }: any) => {
            let gif = featured_gif
            if (!gif || gif.is_hidden || gif.is_removed) {
                gif = getGifSkeleton()
            }
            return { ...gif, url: user.profile_url, user }
        })
    return newGifs
}
